export default {
  title: 'Notícias',
  createPost: 'Criar Publicação',
  titleLabel: 'Título',
  contentLabel: 'Conteúdo',
  viewerLabel: 'Visualizador',
  customizerLabel: 'Personalizador',
  managerLabel: 'Gerente',
  close: 'Fechar',
  save: 'Salvar',
  headerTitle: 'Título',
  headerContent: 'Conteúdo',
  headerProfiles: 'Perfis',
  headerCreator: 'Criador',
  headerCreated: 'Criado',
  headerActions: 'Ações',
  noData: 'Sem dados',
  deleteConfirm: 'Tem certeza de que deseja excluir esta publicação?',
  notAvailable: 'N/D'
}
